import { useMemo } from 'react';
import useFieldValidation from 'hooks/useFieldValidation';
function useVariantValidation({ price, currencyId, color, isColorRequired, sizeName, isSizeRequired }, t) {
    const validatedFields = useMemo(() => {
        const fields = ['price', 'currencyId'];
        if (isSizeRequired)
            fields.push('size');
        if (isColorRequired)
            fields.push('color');
        return fields;
    }, [isColorRequired, isSizeRequired]);
    return useFieldValidation(validatedFields, (field) => {
        if (field === 'price')
            return !price ? t('specification:required_field') : null;
        if (field === 'currencyId')
            return !currencyId ? t('specification:required_field') : null;
        if (field === 'size')
            return !(sizeName === null || sizeName === void 0 ? void 0 : sizeName.trim()) ? t('specification:required_field') : null;
        if (field === 'color')
            return !(color === null || color === void 0 ? void 0 : color.trim()) ? t('specification:required_field') : null;
        return null;
    }, (field) => {
        if (field === 'price')
            return t('common:price');
        if (field === 'currencyId')
            return t('common:currency');
        if (field === 'size')
            return t('common:size');
        if (field === 'color')
            return t('common:color');
        return field;
    });
}
export default useVariantValidation;
